import React, { useState , useEffect , useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import {
  faPenToSquare,
  faCheck,
  faXmark, faLanguage , 
} from "@fortawesome/free-solid-svg-icons";

import ViewOptionListTable from "./ViewOptionListTable";
import Modal from "@/components/Modal";
import SingleTempRecord from "./SingleTempRecord";

import {
  fetchSubCategoryData,
  fetchVTypeData,
  fetchCategoryData,
} from "@/slices/panelSlice";

import {
  fetchVariableList,
  updateVariableList,
  setSelectedVariableId,
} from "@/slices/panelSlice/variableListSlice";

import { fetchLanguageList } from "@/slices/panelSlice/languageSlice";
import SingleCountryOptionList from "./SingleCountryOptionList";
import SingleQuestionTitleTrans from "./SingleQuestionTitleTrans";
import SingleQuestionSubTitleTrans from "./SingleQuestionSubTitleTrans";


function ViewSingleVariableList({ data }) {

  // console.log(data)
  
  const dispatch = useDispatch();

  const { variableList, selectedVariableId } = useSelector(
    (state) => state.variableList
  );

  const item = useMemo(() => {
    return (
      variableList?.QuestionList?.find(
        (v) => v.id === (selectedVariableId || data?.[0]?.id)
      ) || {}
    );
  }, [variableList, selectedVariableId, data]);

  const { VTypeData, categoryData, subCategoryData } = useSelector(
    (state) => state.panel
  );
 
const vTypeOptions = VTypeData?.result || [];
const categoryOptions = categoryData?.result || [];
const subCategoryOptions = subCategoryData?.result || [];

  const languageList = useSelector((state) => state.language);

 useEffect(() => {
    dispatch(fetchLanguageList())
    // dispatch(fetchVariableList());

      if (!variableList?.QuestionList?.length) {
         dispatch(fetchVariableList());
       }

    dispatch(fetchVTypeData());
    dispatch(fetchCategoryData());
    dispatch(fetchSubCategoryData());
  }, [dispatch , variableList]);

  // ================= ORIGINAL DATA (for cancel reset) =================
  const originalDetails = {
    title: item.title,
    comment: item.comment,
    category: item.category,
    subCategory: item.subCategory,
    variableType: item.variableType,
  };

  const originalBool = {
    is_active: item.is_active,
    editable: item.editable,
    optional: item.optional,
    is_option: item.is_option,
    is_countryOption: item.is_countryOption,
  };

useEffect(() => {
  if (!item?.id) return;

  setDetails({
    title: item.title,
    comment: item.comment,
    category: item.category,
    subCategory: item.subCategory,
    variableType: item.variableType,
  });

  setQuestionTitle({
    title: item.Question_title || "",
    subTitle: item.Question_Subtitle || "",
  });

  setBoolData({
    is_active: item.is_active,
    editable: item.editable,
    optional: item.optional,
    is_option: item.is_option,
    is_countryOption: item.is_countryOption,
  });

}, [item]);

  // ================= STATES =================
  const [editDetails, setEditDetails] = useState(false);
  const [editTitle, setEditTitle] = useState(false);
  const [editSettings, setEditSettings] = useState(false);
  const [details, setDetails] = useState(originalDetails);

  const [questionTitle, setQuestionTitle] = useState({
      title: item.Question_title || "",
      subTitle: item.Question_Subtitle || "",
    });

  const [boolData, setBoolData] = useState(originalBool);
  const [tempRecord, setTempRecord] = useState();
  const [tempDis, setTempDis] = useState(false);

  const [cOptionsDis, setCoptionsDis] = useState(false);

const [translateTitleModal, setTranslateTitleModal] = useState(false);
const [translateSubtitleModal, setTranslateSubtitleModal] = useState(false);
const [pendingRequest, setPendingRequest] = useState(0);

useEffect(() => {
  const count =
    item?.Temp_Record?.filter((record) => record.Used === false).length || 0;
  setPendingRequest(count);
}, [item]);
  
  // ================= HANDLERS =================
  const handleCheckbox = (key) => {
    setBoolData((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // ================= CANCEL =================
  const cancelDetails = () => {
    const item = data?.[0] || {};
    setDetails({
      title: item.title,
      comment: item.comment,
      category: item.category,
      subCategory: item.subCategory,
      variableType: item.variableType,
    });
    setEditDetails(false);
  };

  const cancelTitle = () => {
    const item = data?.[0] || {};
    setQuestionTitle({
      title: item.Question_title || "",
      subTitle: item.Question_Subtitle || "",
    });
    setEditTitle(false);
  };

  const cancelSettings = () => {
    const item = data?.[0] || {};
    setBoolData({
      is_active: item.is_active,
      editable: item.editable,
      optional: item.optional,
      is_option: item.is_option,
      is_countryOption: item.is_countryOption,
    });
    setEditSettings(false);
  };


   const handleTempRecord = ()=>{
    let finalObj = {id:item.id,tempData:item.Temp_Record};
    setTempRecord(finalObj);
    setTempDis(true);
  }

    const handleCountryOptionList = ()=>{
    setCoptionsDis(true)
  }



const handleSaveAll = async () => {
  try {
    const variableTypeId = VTypeData?.result?.find(
      (f) => f.title === details.variableType
    )?.id;

    const categoryId = categoryData?.result?.find(
      (f) => f.title === details.category
    )?.id;

    const subCategoryId = subCategoryData?.result?.find(
      (f) => f.title === details.subCategory
    )?.id;

    const finalData = {
      id: item.id,
      title: details.title,
      comment: details.comment,
      variableType: variableTypeId,
      category: categoryId,
      subCategory: subCategoryId,

      optional: boolData.optional,
      editable: boolData.editable,
      is_active: boolData.is_active,
      is_countryOption: boolData.is_countryOption,
      is_option: boolData.is_option,

     QuestionTitle: {
      title: questionTitle.title,
      subTitle: questionTitle.subTitle,
    },

    };

    const resp = await dispatch(updateVariableList(finalData));

    if (!resp.error) {
      await dispatch(fetchVariableList());

      setEditDetails(false);
      setEditTitle(false);
      setEditSettings(false);
      cancelDetails();
      cancelTitle();
      cancelSettings();
    }
  } catch (err) {
    console.log(err);
  }
};


  // ================= UI FIELD =================
const renderField = (
  label,
  key,
  value,
  isEdit,
  onChange,
  type = "text",
  options = []
) => {
  return (
    <div className="flex flex-col border-b py-2">
      <p className="text-xs font-bold text-gray-500 uppercase">{label}</p>

      {isEdit ? (
        type === "select" ? (
          <select
            value={value || ""}
            onChange={(e) => onChange(key, e.target.value)} // ✅ store name
            className="border p-2 rounded text-sm mt-1 bg-white"
          >
            <option value="">Select {label}</option>

           {Array.isArray(options) &&
            options.map((opt, i) => (
              <option key={i} value={opt.title}>
                {opt.title}
              </option>
            ))}
          </select>
        ) : (
          <input
            value={value || ""}
            onChange={(e) => onChange(key, e.target.value)}
            className="border p-2 rounded text-sm mt-1"
          />
        )
      ) : (
        <p className="text-sm font-medium text-gray-800 mt-1">
          {value || "-"} {/* ✅ directly show name */}
        </p>
      )}
    </div>
  );
};

  return (
    <div className="p-3 space-y-6 bg-gray-50">
      
      <div className="flex justify-between items-center bg-white p-3 rounded-lg border shadow-sm">
        <div className="flex items-center gap-4">
          <p className="text-sm font-medium text-gray-600">Select Variable:</p>
          <select
            value={item.id || ""}
            onChange={(e) => {
              const id = Number(e.target.value);
              dispatch(setSelectedVariableId(id));
            }}
            className="border p-2 rounded text-sm bg-white min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Variable</option>
            {variableList?.QuestionList?.map((v) => (
              <option key={v.id} value={v.id}>
                {v.title}
              </option>
            ))}
          </select>
        </div>

        <div className="">
          <p className="text-sm text-gray-600">Current Title: <span className="font-bold text-lg text-gray-900">{details.title}</span> </p>
        </div>

         <div className="flex justify-end gap-2">
      { (item.is_option && item.variableType==="Single" || item.variableType==="Multi") &&  <button
            type="button"
             onClick={handleCountryOptionList}
              className="relative bg-blue-500 hover:bg-blue-600 text-white py-1.5 px-3 rounded-lg border shadow-sm text-xs">
              Country Masking
          </button>}
          <button
            type="button"
            onClick={handleTempRecord}
            className="relative bg-blue-500 hover:bg-blue-600 text-white py-1.5 px-3 rounded-lg border shadow-sm text-xs"
          >
            Temp Options

            {/* Badge */}
            {pendingRequest > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-semibold px-2 py-[2px] rounded-full">
                {pendingRequest}
              </span>
            )}
          </button>
        </div>
      </div>


      {/* ================= DETAILS ================= */}
      <div className="bg-white p-4 rounded-lg border shadow-sm">
          
        <div className="flex justify-between items-center mb-1">
          <h2 className="text-lg font-bold">DETAILS</h2>

          {!editDetails ? (
            <button onClick={() => setEditDetails(true)}>
              <FontAwesomeIcon icon={faPenToSquare} />
            </button>
          ) : (
            <div className="flex gap-3">
              <button onClick={handleSaveAll} className="text-green-600">
                <FontAwesomeIcon icon={faCheck} />
              </button>
              <button onClick={cancelDetails} className="text-red-600">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          )}
        </div>

        <div className="grid grid-cols-3 md:grid-cols-5 gap-4">

          {/* {renderField(
            "Title",
            "title",
            details.title,
          )} */}

          {renderField(
            "Comment",
            "comment",
            details.comment,
            editDetails,
            (k, v) => setDetails({ ...details, [k]: v })
          )}

       {renderField(
          "Category",
          "category",
          details.category,
          editDetails,
          (k, v) => setDetails({ ...details, [k]: v }),
          "select",
          categoryOptions
        )}

        {renderField(
          "Sub Category",
          "subCategory",
          details.subCategory,
          editDetails,
          (k, v) => setDetails({ ...details, [k]: v }),
          "select",
          subCategoryOptions
        )}

        {renderField(
          "Variable Type",
          "variableType",
          details.variableType,
          editDetails,
          (k, v) => setDetails({ ...details, [k]: v }),
          "select",
          vTypeOptions
        )}
        </div>
      </div>

      {/* ================= QUESTION TITLE ================= */}
      <div className="bg-white p-4 rounded-lg border shadow-sm">

        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-bold">QUESTION TITLE</h2>

          {!editTitle ? (
            <button onClick={() => setEditTitle(true)}>
              <FontAwesomeIcon icon={faPenToSquare} />
            </button>
          ) : (
            <div className="flex gap-3">
              <button onClick={handleSaveAll} className="text-green-600">
                <FontAwesomeIcon icon={faCheck} />
              </button>
              <button onClick={cancelTitle} className="text-red-600">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          )}
        </div>

     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

  {/* Question Title */}
  <div className="relative">
    {renderField(
      "Question Title",
      "title",
      questionTitle.title,
      editTitle,
      (k, v) =>
        setQuestionTitle((prev) => ({
          ...prev,
          [k]: v,
        }))
    )}

    <button
      onClick={() => setTranslateTitleModal(true)}
      className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
      title="Translate Title"
    >
      <FontAwesomeIcon icon={faLanguage} className="text-[25px]" />
    </button>
  </div>

  {/* Question Subtitle */}
  <div className="relative">
    {renderField(
      "Question Subtitle",
      "subTitle",
      questionTitle.subTitle,
      editTitle,
      (k, v) =>
        setQuestionTitle((prev) => ({
          ...prev,
          [k]: v,
        }))
    )}

    <button
      onClick={() => setTranslateSubtitleModal(true)}
      className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
      title="Translate Subtitle"
    >
      <FontAwesomeIcon icon={faLanguage} className="text-[25px]"/>
    </button>
  </div>
  </div>
      </div>

      {/* ================= SETTINGS ================= */}
      <div className="bg-white p-4 rounded-lg border shadow-sm">

        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">SETTINGS</h2>

          {!editSettings ? (
            <button onClick={() => setEditSettings(true)}>
              <FontAwesomeIcon icon={faPenToSquare} />
            </button>
          ) : (
            <div className="flex gap-3">
              <button onClick={handleSaveAll} className="text-green-600">
                <FontAwesomeIcon icon={faCheck} />
              </button>
              <button onClick={cancelSettings} className="text-red-600">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-3">

          {Object.entries(boolData).map(([key, value]) => (
            <label
              key={key}
              className="flex justify-between items-center border rounded px-2 py-1.5 bg-gray-50"
            >
              <span className="text-sm font-semibold uppercase">
                {key.replace(/_/g, " ")}
              </span>

              <input
                type="checkbox"
                checked={value}
                disabled={!editSettings}
                onChange={() => handleCheckbox(key)}
                className="w-4 h-4 accent-blue-500"
              />
            </label>
          ))}

        </div>
      </div>

      {/* ================= OPTION LIST ================= */}
      {(item.variableType==="Single" || item.variableType==="Multi") &&
      <div className="bg-white p-4 rounded-lg border shadow-sm">
        <h2 className="text-lg font-bold mb-3">OPTION LIST</h2>
         <ViewOptionListTable options={item.option_List} currId={item.id}   />
      </div>}

        <Modal
        isOpen={tempDis}
        onClose={()=>setTempDis(false)}
        title="Temp Records"
        content={<SingleTempRecord
        rowData={tempRecord} />}
        />

        <Modal
         isOpen={cOptionsDis}
         onClose={()=>setCoptionsDis(false)}
         title="Country Options List"
         content={<SingleCountryOptionList
         rowData={item} />}
      />

      <Modal
      isOpen={translateTitleModal}
      onClose={() => setTranslateTitleModal(false)}
      title="Translate Question Title"
      content={
       <SingleQuestionTitleTrans 
        currLang={item}  
        langList={languageList?.data?.result} />
      }
    />

    <Modal
      isOpen={translateSubtitleModal}
      onClose={() => setTranslateSubtitleModal(false)}
      title="Translate Question Subtitle"
      content={
        <SingleQuestionSubTitleTrans 
            currLang={item}  
            langList={languageList?.data?.result} 
        />
      }
    />
    </div>
  );
}

export default ViewSingleVariableList;